// EG funnel shared constants (Egypt landing + sub-pages)
// Hosted MP4 — served from Emergent customer-assets CDN with proper Range support.
export const EG_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_charisma-protocol/artifacts/hh0fys77_lv_0_20260528225002.mp4";

export const EG_VIDEO_LABEL = "eg-sample-video";

export const EG_PREVIEW_PAGES = [
  "/preview-eg/P1.png",
  "/preview-eg/P2.png",
  "/preview-eg/P3.png",
];

export const EG_NAV = [
  { to: "/eg/about", label: "ما هو الكتاب الأزرق", testid: "nav-eg-about" },
  { to: "/eg/sample", label: "عينة من الكتاب", testid: "nav-eg-sample" },
  { to: "/eg/community", label: "انضم لمجتمعنا", testid: "nav-eg-community" },
  { to: "/eg/refund", label: "سياسة الاسترجاع", testid: "nav-eg-refund" },
  { to: "/eg/contact", label: "للتواصل", testid: "nav-eg-contact" },
];
